/*
  LinkSelector.jsx
*/

// Npm.
import React from 'react';

// Util.
import { DEFAULT_NODE_COLOR } from '../utils/constants';

// Components.
import Autocomplete from './Autocomplete';

// Makes.
import { makeStyles } from '../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  linkIcon: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: 4,
  },
}));

// Helpers.
function getLinkColor(link) {
  return link?.source?._botech?.color || DEFAULT_NODE_COLOR;
}
function getLinkLabel(link) {
  const name = link._botech?.label || `${link.source?._botech?.label || link.source?.id || '_'} → ${link.target?._botech?.label || link.target?.id || '_'}`;
  return `${name} <${link.id}>`;
}

/**
 * Selector for Links.
 */
export default function LinkSelector({
  links,
  multiple = false,
  ...rest
}) {

  const classes = useStyles();

  return (
    <Autocomplete
      options={links}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      getOptionLabel={getLinkLabel}
      getOptionValue={link => link.id || null}
      getOptionIcon={link => (
        <span
          className={classes.linkIcon}
          style={{ backgroundColor: getLinkColor(link) }}
        />
      )}
      {...rest}
    />
  );
};
